import { CampaignName, SlotDate, SlotGridType, SlotTime } from 'api/definitions/slotdates/types';
import { Campaign } from 'redux/modules/slot-dates/state/initial-state';

type Action = {
  payload: {
    slotDates: SlotDate[];
    slotTimes: {
      slotGridType: SlotGridType;
      slotTimes: SlotTime[];
    }[];
    campaigns: Partial<Record<CampaignName, Campaign>>;
  };
};

const reducer = (state: WtrState, action: Action) => {
  const { slotDates, slotTimes } = action.payload;
  return {
    ...state,
    dates: slotDates,
    times: slotTimes,
    loading: false,
    error: null,
  };
};

export default reducer;
